import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader } from "../../MenuCard";

const ITEMS = [
  { label: "Compras",          icon: "fas fa-money-check-alt",     color: "#f59e0b", bg: "#fffbeb", href: "/ListadoComprasCXP",       desc: "Compras y facturas",       perm: "edoCtaProveedores" },
  { label: "Abonos",           icon: "fas fa-dollar-sign",         color: "#10b981", bg: "#f0fdf4", href: "/ListadoAbonosProveedores", desc: "Pagos a proveedores",     perm: "pagoProveedores" },
  { label: "Estado Cuenta",    icon: "fas fa-file-invoice-dollar", color: "#3b82f6", bg: "#eff6ff", href: "/EstadoCuentaCXP",         desc: "Estado por proveedor",     perm: "edoCtaProveedores" },
];

function BotonesCXP() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-file-invoice" color="#f59e0b" bg="#fffbeb" title="CXP" subtitle="Cuentas por pagar a proveedores" />
        {user.pagoProveedores ? (
          <div className="row">
            {ITEMS.map((r, i) => (
              <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            ))}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesCXP;
